export const styles = {
  gap: { gap: 6 },
};
